import React from 'react'
import { css } from 'emotion'
import {
  Segment,
  Grid,
  Container,
  Header,
  List,
  Icon,
  Modal,
  Form,
  Button,
  Input,
  TextArea,
} from 'semantic-ui-react'
import { Link } from 'gatsby'
import { LicenseFooter } from './LicenseFooter'

export const styles = {}
styles.footer = css`
  width: 100%;
  display: flex;
  justify-content: space-around;
  section {
    border-right: 1px solid black;
    width: 100%;
    padding: 10px;
    margin: 10px;
  }
  section:last-child {
    border-right: 0 transparent;
  }
  button.link-like-button {
    background: none;
    border: none;
    padding-left: 0;
    color: #4183c4;
    :hover {
      color: #1e70bf;
      cursor: pointer;
    }
  }
`

export const Footer = () => (
  <Segment as="footer" vertical inverted className={styles.footer}>
    <Container>
      <Grid columns={3} inverted stackable divided>
        <Grid.Column>
          <Header inverted>Esmer games</Header>
          <List>
            <List.Item>
              <Link to="/about">
                <Icon name="question" /> About
              </Link>
            </List.Item>
            <List.Item>
              <Modal
                trigger={
                  <button className="link-like-button">
                    <Icon name="envelope" /> Contact me
                  </button>
                }
              >
                <Modal.Header>Contact me</Modal.Header>
                <Modal.Content>
                  <Modal.Description>
                    <Form
                      action="https://formspree.io/esmer.games.blog@gmail.com"
                      method="POST"
                    >
                      <Form.Field
                        name="name"
                        control={Input}
                        label="Name"
                        placeholder="Your name or something to identify you"
                      />
                      <Form.Field
                        name="body"
                        control={TextArea}
                        label="Message body"
                        placeholder="Your message"
                      />
                      <Button type="submit">Submit</Button>
                    </Form>
                  </Modal.Description>
                </Modal.Content>
              </Modal>
            </List.Item>
          </List>
        </Grid.Column>
        <Grid.Column>
          <Header inverted>Social</Header>
          <a href="https://www.instagram.com/esmergames">
            <Icon size="big" name="instagram" />
          </a>
          <a href="https://twitter.com/BlogEsmer">
            <Icon size="big" name="twitter" />
          </a>
          <a href="https://www.facebook.com/Esmer-Games-348138162663198/">
            <Icon size="big" name="facebook" />
          </a>
          {/* unused atm <a href="https://www.reddit.com/user/esmer-man">
            <Icon size="big" name="reddit" />
          </a> */}
        </Grid.Column>
        <Grid.Column>
          <Header inverted>Technologies</Header>
          <List>
            <List.Item>
              <a href="https://reactjs.org/">
                <Icon name="react" />
                React
              </a>
            </List.Item>
            <List.Item>
              <a href="https://nodejs.org/">
                <Icon name="node js" />
                NodeJS
              </a>
            </List.Item>
            <List.Item>
              <a href="https://www.gatsbyjs.org/">Gatsby</a>
            </List.Item>
            <List.Item>
              <a href="https://react.semantic-ui.com/">Semantic UI React</a>
            </List.Item>
            <List.Item>
              <a href="https://pages.github.com/">
                Hosted at <Icon name="github" />
                Github pages
              </a>
            </List.Item>
          </List>
        </Grid.Column>
      </Grid>
      <LicenseFooter />
    </Container>
  </Segment>
)
